import type {
    INCoreUIKitIconProps
} from "../../../types";
import {
    LinearGradient,
    Path,
    Defs,
    Stop,
    Svg
} from "react-native-svg";

const NIBGATIcon = ({
    size = 30,
    style,
    ...props
}: INCoreUIKitIconProps) => {
    const pathScale = 620 / size;

    return <Svg
        height={size}
        width={size}
        fill="none"
        {...props}
        style={{
            ...style
        }}
    >
        <Path
            d="m171.363 110.098 138.558-80.013 138.557 80.013v159.987l138.18 79.635v159.987L448.1 589.72l-137.801-80.013-138.558 80.013-138.557-80.013V349.72l138.179-79.635V110.098Z"
            transform={[
                {
                    scale: 1 / pathScale
                }
            ]}
            fill="url(#nibgat_gradient)"
            fillOpacity={0.922}
            clipRule="evenodd"
            fillRule="evenodd"
        />
        <Path
            d="m222.613 198.652 21.808-37.795 21.846-37.834h87.307l21.846 37.834 21.807 37.795-21.807 37.833-21.846 37.795h-87.307l-21.846-37.795-21.808-37.833ZM353.574 425.537l21.846-37.834 21.808-37.795h87.345l21.808 37.795 21.845 37.834-21.845 37.795-21.808 37.833h-87.345l-21.808-37.833-21.846-37.795ZM91.615 425.537l21.846-37.834 21.808-37.795h87.345l21.808 37.795 21.845 37.834-21.845 37.795-21.808 37.833h-87.345l-21.808-37.833-21.846-37.795Z"
            transform={[
                {
                    scale: 1 / pathScale
                }
            ]}
            strokeOpacity={0.69}
            strokeWidth={6.65}
            clipRule="evenodd"
            stroke="#323232"
        />
        <Path
            d="m353.574 123.024 25.625-52.914M397.229 198.652h51.25M266.267 123.023l-29.329-50.796M222.614 198.652h-51.251M484.572 349.908l25.512-44.296M528.227 425.537h58.431M484.572 501.165l29.216 50.646M397.227 501.165l-25.625 44.145M222.613 501.165l25.625 44.372M135.268 501.165l-29.215 50.646M91.615 425.537H33.184M135.268 349.908l-25.512-44.296"
            transform={[
                {
                    scale: 1 / pathScale
                }
            ]}
            strokeOpacity={0.69}
            strokeWidth={5.669}
            stroke="#323232"
        />
        <Path
            d="m222.613 349.909 21.808-37.796 21.846-37.833h87.307l21.846 37.833 21.807 37.796-21.807 37.795-21.846 37.833h-87.307l-21.846-37.833-21.808-37.795Z"
            transform={[
                {
                    scale: 1 / pathScale
                }
            ]}
            strokeWidth={6.65}
            clipRule="evenodd"
            fillRule="evenodd"
            stroke="#323232"
            fill="#323232"
        />
        <Path
            d="m284.031 298.394-29.707 51.515 29.707 51.514M335.811 298.394l29.707 51.515-29.707 51.514M284.031 298.394l51.78 103.029"
            transform={[
                {
                    scale: 1 / pathScale
                }
            ]}
            strokeLinejoin="round"
            strokeOpacity={0.941}
            strokeLinecap="round"
            strokeWidth={9.449}
            stroke="#FBFBFB"
        />
        <Defs>
            <LinearGradient
                gradientUnits="userSpaceOnUse"
                x1={484.077 / pathScale}
                x2={135.764 / pathScale}
                y2={531.137 / pathScale}
                y1={88.682 / pathScale}
                id="nibgat_gradient"
            >
                <Stop
                    stopColor="#36B49E"
                />
                <Stop
                    stopColor="#068F7C"
                    offset={1}
                />
            </LinearGradient>
        </Defs>
    </Svg>;
};
export default NIBGATIcon;
